import React from 'react';
import Header from '../components/Header';
import WorksHighlights from '../components/WorksHighlights';
import Sheet from '../components/Sheet';
import Vrc from '../components/Vrc';
import BlogHighlights from '../components/BlogHighlights';

function Works() {
  return (
    <>
      <Header />
      <WorksHighlights />
      <Sheet />
      <Vrc />
      <BlogHighlights />
    </>
  );
}

export default Works;
